import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.RelationshipValidation = function () {
        const dictonary = {
            custom: {
                RelateType: {
                    required: () => t.t(dictEnum.LBL_Type) + t.t(dictEnum.WARN_IsRequired)
                },
                CDesc: {
                    required: () => t.t(dictEnum.LBL_ChiDesc) + t.t(dictEnum.WARN_IsRequired)
                },
                EDesc: {
                    required: () => t.t(dictEnum.LBL_EngDesc) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081400-Relationship/S081400-RelationshipValidation.js